const basePath = 'billing/product_validations/'

export default {
  /*
   * index() lista las validaciones de producto del usuario
   */
  async index(params, skipLoading = false) {
    return Vue.http.get(basePath, {params, skipLoading}).then(response => response.data.data)
  }
}
